<template>
    <v-row justify="center">
      <v-dialog
        v-model="value"
        content-class="elevation-0"
        :max-width="maxWidth"
        persistent
      >
        <v-container>
          <v-card
            height="auto"
            style="border-radius: 40px 40px 40px 40px"
            color="white"
          >
            <v-card-title
              v-if="showClose"
              class="d-flex justify-end"
            >
            <v-icon color="gray" @click="closeDialog()">
              mdi-close
            </v-icon>
          </v-card-title>
          
          <p class="text-center break-word" style="color: #313945; font-weight: bold; font-size: 34px;">{{ title }}</p>

            <section class="container px-8">
              <slot name="content" />
            </section>
  
            <div class="actions-buttons pl-5 pb-5" :class="classButtons">
              <slot name="actions" />
            </div>
          </v-card>
        </v-container>
      </v-dialog>
    </v-row>
  </template>
  
  <script>
  export default {
    props: {
      title: String,
      showClose: {
        type: Boolean,
        default: true,
      },
      value: Boolean,
      maxWidth: {
        type: String,
        default: 600,
      },
      classButtons: {
        type: String,
        default: "d-flex justify-end",
      },
    },
    methods: {
      closeDialog() {
        this.$emit("input", false);
        this.$emit("closeIcon");
      },
    },
  };
  </script>
  
  <style scoped>
  .actions-buttons button {
    margin-right: auto;
    margin-left: auto;
  }
  </style>
  